import GeneralForm from "components/GeneralForm";
import { hideLoading } from "components/Loading";
import { showLoading } from "components/Loading";
import { validate } from "components/validateGeneralForm";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Input, Modal, ModalBody } from "reactstrap";
import ordemServicoService from "services/OrdemServicoService";
import { erroInesperado } from "services/Utils";
import { onlyNumbers } from "services/Utils";
import { formatNumber } from "services/Utils";

export default function ModalAlterarMovimentacao({ config, onClosed }) {
  const [data, setData] = useState({})

  useEffect(() => {
    if (config) {
      setData({
        quantidadeExecutadoFmt: config.quantidadeExecutadoFmt
      })
    } else {
      setData({})
    }
  }, [config])

  const formConfig = [
    [
      { name: "quantidadeExecutadoFmt", label: 'Quantidade informada', type: "text", required: true, colspan: 12, disabled: true },
      { name: "quantidade", label: 'Quantidade corrigida', type: "decimal", required: true, colspan: 12 },
      { name: "observacao", label: 'Observação', type: "text", required: true, colspan: 12 },
    ]
  ]

  const handleChange = (name, value) => {
    setData({ ...data, [name]: value })
  }

  const handleSubmit = async (ev) => {
    ev.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData({ ...data, errors })
      return
    }

    try {
      showLoading()
      await ordemServicoService.alterarMovimentacao(config.idOrdemServico, config.idItem, data.quantidade, data.observacao)
      hideLoading()
      toast('Registro alterado com sucesso!')
      config.onChanged && config.onChanged()
      onClosed && onClosed()
    } catch (ex) {
      hideLoading()
      erroInesperado()
    }
  }

  return (
    <Modal isOpen={!!config} size="lg">
      <ModalBody>
        <h2></h2>
        <hr />
        <form onSubmit={handleSubmit}>
          <GeneralForm
            config={formConfig}
            data={data}
            onChange={handleChange}
            disabled={false}
          />

          <div className="text-right mt-4">
            <Button type="submit" color="primary">Salvar</Button>
            <Button type="button" color="primary" outline onClick={onClosed}>Cancelar</Button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
}